import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Images } from "../../../utils/Images";

const cards = [
  {
    id: 1,
    icon: Images.greenBox,
    title: "Same-Day Delivery",
    subtitle: "Products delivered fresh within 24 hours of purchase",
  },
  {
    id: 2,
    icon: Images.greenCamera,
    title: "Update on Social Media",
    subtitle: "You receive delivery photos as confirmation",
  },
  {
    id: 3,
    icon: Images.greenVerified,
    title: "Verified NGO",
    subtitle: "Registered & audited non-profit partner",
  },
  {
    id: 4,
    icon: Images.greenBill,
    title: "80G Tax Receipt",
    subtitle: "Tax deduction receipt sent via email",
  },
];

const WhereProductsGoSection = ({ vendor }) => {
  const isMobile = useMediaQuery("(max-width: 599.95px)");
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:899.95px)");
  const isLaptop = useMediaQuery("(min-width:900px) and (max-width:1199.95px)");
  const isDesktop = useMediaQuery("(min-width: 1200px)");

  return (
    <Box sx={{ width: isDesktop ? "94.44%" : "100%", maxWidth: "1440px", mx: "auto", px: isDesktop ? 0 : "16px", mb: isMobile ? "24px" : "90px" }}>
      <Box sx={{ position: "relative", display: "flex", flexDirection: "column", alignItems: isMobile ? "flex-start" : "center", gap: isMobile ? "8px" : "40px" }}>
        {isDesktop && (
          <>
            <Box
              component="img"
              src={Images.orangeSparks}
              alt="orange sparks"
              sx={{ position: "absolute", top: "24px", left: "56px", width: "49.843px", height: "71.204px" }}
            />
            <Box
              component="img"
              src={Images.yellowHearts}
              alt="yellow hearts"
              sx={{ position: "absolute", top: "63px", right: "58px", width: "30.967px", height: "40.023px" }}
            />
          </>
        )}

        <Box sx={{ display: "flex", flexDirection: "column", alignItems: isMobile ? "flex-start" : "center", gap: isMobile ? "10px" : "20px", width: "100%", maxWidth: "1360px" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: isMobile ? "10px" : "12px", height: "18.973px" }}>
            <Box sx={{ width: "8px", height: "8px", borderRadius: "50%", background: "#8EA946" }} />
            <Typography sx={{ fontWeight: 400, fontSize: isMobile ? "10px" : "14px", lineHeight: isMobile ? 1 : "18.2px", letterSpacing: isMobile ? "2px" : "2.1px", textTransform: "uppercase", color: "#131313" }}>
              Where Your Products Go
            </Typography>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", alignItems: isMobile ? "flex-start" : "center", gap: isMobile ? "14px" : "14px", width: "100%" }}>
            <Typography sx={{ fontWeight: 700, fontSize: isDesktop ? "36px" : isTablet || isLaptop ? "30px" : "18px", lineHeight: isMobile ? "29.124px" : "1.4", letterSpacing: "-0.36px", textAlign: isMobile ? "left" : "center", color: "#1D1D1B", maxWidth: isMobile ? "100%" : "none" }}>
              {vendor?.where_products_go_title || "Where your products go"}
            </Typography>
            <Typography sx={{ fontWeight: 400, fontSize: isMobile ? "12px" : "16px", lineHeight: isMobile ? "20px" : "25.888px", letterSpacing: isMobile ? "-0.24px" : "normal", textAlign: isMobile ? "left" : "center", color: "#7D7D7D", maxWidth: isMobile ? "100%" : "1060px" }}>
              {vendor?.where_products_go_description || ""}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ width: "100%", display: "grid", gridTemplateColumns: isDesktop || isLaptop ? "repeat(2, minmax(0, 1fr))" : "1fr", gap: isMobile ? "10px" : "20px" }}>
          {cards.map((item) => (
            <Box
              key={item.id}
              sx={{
                minHeight: isMobile ? "82px" : "100px",
                borderRadius: isMobile ? "12px" : "22px",
                border: "1px solid #F1F1F1",
                background: "#FFFFFF",
                boxShadow: isMobile ? "none" : "0px 4px 14px rgba(0, 0, 0, 0.04)",
                display: "flex",
                alignItems: isMobile ? "flex-start" : "center",
                px: isDesktop ? "20px" : isTablet ? "18px" : "14px",
                py: isMobile ? "12px" : "18px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: isMobile ? "flex-start" : "center", gap: isMobile ? "10px" : "14px" }}>
                <Box
                  sx={{
                    width: isMobile ? "44px" : "52px",
                    height: isMobile ? "44px" : "52px",
                    borderRadius: isMobile ? "8.123px" : "9.6px",
                    background: "#F5F8ED",
                    p: isMobile ? "8.462px" : "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Box component="img" src={item.icon} alt={item.title} sx={{ width: isMobile ? "22px" : "26.667px", height: isMobile ? "22px" : "26.667px" }} />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: isMobile ? "6px" : "10px" }}>
                  <Typography sx={{ fontWeight: 600, fontSize: isMobile ? "12px" : "16px", lineHeight: isMobile ? 1 : 1, letterSpacing: "-0.24px", color: "#1D1D1B" }}>
                    {item.title}
                  </Typography>
                  <Typography sx={{ fontWeight: 400, fontSize: isMobile ? "12px" : "14px", lineHeight: isMobile ? "14px" : 1, letterSpacing: "-0.12px", color: "#7D7D7D" }}>
                    {item.subtitle}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default WhereProductsGoSection;
